module.exports = __webpack_public_path__ + "static/media/05.3498ac20.png";